import { CommandPaletteError } from './command-palette-error';

/**
 * Error for prefill validation failures: a caller opened a view with a
 * prefill payload that didn't satisfy the view's `prefillSchema`. The
 * view still opens (with `undefined` prefill) so the user isn't
 * stranded, but the dropped payload is a low-severity defect worth
 * reporting to telemetry via `onError`.
 */
const validationMarker = 'command-palette.validation.error';
const validationSymbol = Symbol.for(validationMarker);

export class CommandPaletteValidationError extends CommandPaletteError {
  private readonly [validationSymbol] = true;

  readonly view: { id: string };

  constructor({ view, message, cause }: { view: { id: string }; message: string; cause?: unknown }) {
    super({ name: 'CommandPaletteValidationError', message, cause });
    this.view = view;
  }

  static isInstance(error: unknown): error is CommandPaletteValidationError {
    return CommandPaletteError.hasMarker(error, validationMarker);
  }
}
